export const CATEGORY: string = 'Kaitoriya';
